// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import { OptionsTooltip_ReadyPlanOptionFragmentDoc, OptionsTooltip_ReadyPlanOptionGroupFragmentDoc } from '../../../../developments/product-offerings/components/OptionsTooltipContent.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewStepQueryVariables = Types.Exact<{
  planPackageId: Types.Scalars['ID']['input'];
  exteriorDesignPackageId: Types.Scalars['ID']['input'];
  interiorDesignPackageId: Types.Scalars['ID']['input'];
  readyPlanOptionsFilter: Types.ReadyPlanOptionsFilter;
}>;


export type ReviewStepQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, name: string, displayCode?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType }, asset: { __typename?: 'Asset', id: string, planPackagePreview?: string | null | undefined } }> }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, name: string, order: number }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, required: boolean, order: number, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, code: string, name: string }, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, optionDefaultsIf: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }> }> };

export type ReviewStep_SaveProductOfferingMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingInput;
}>;


export type ReviewStep_SaveProductOfferingMutation = { __typename?: 'Mutation', saveProductOffering: { __typename?: 'SaveProductOfferingResult', productOffering: { __typename?: 'ProductOffering', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } } };

export type ReadOnlyReadyPlanOptionRowFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, name: string, order: number }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, required: boolean, order: number, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, code: string, name: string }, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, optionDefaultsIf: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }> };

export type ProgramDataFragment = { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined };

export const ReadOnlyReadyPlanOptionRowFragmentDoc = gql`
    fragment ReadOnlyReadyPlanOptionRow on ReadyPlanOption {
  id
  name
  displayName
  active
  order
  type {
    id
    isElevation
    name
    order
  }
  optionGroup {
    id
    name
    isMultiOptionGroup
    isSingleOptionGroup
    groupPrerequisites {
      ...OptionsTooltip_ReadyPlanOptionGroup
    }
    required
    order
    group {
      id
      name
    }
  }
  location {
    id
    name
  }
  globalOption {
    id
    code
    name
  }
  optionPrerequisites {
    ...OptionsTooltip_ReadyPlanOption
  }
  optionConflicts {
    ...OptionsTooltip_ReadyPlanOption
  }
  optionConflictChildren {
    ...OptionsTooltip_ReadyPlanOption
  }
  optionDefaultsIf {
    id
    name
    code
  }
}
    ${OptionsTooltip_ReadyPlanOptionGroupFragmentDoc}
${OptionsTooltip_ReadyPlanOptionFragmentDoc}`;
export const ProgramDataFragmentDoc = gql`
    fragment programData on ProgramData {
  id
  bedrooms
  fullBaths
  sellableSqft
  depthInFeet
  widthInFeet
}
    `;
export const ReviewStepDocument = gql`
    query ReviewStep($planPackageId: ID!, $exteriorDesignPackageId: ID!, $interiorDesignPackageId: ID!, $readyPlanOptionsFilter: ReadyPlanOptionsFilter!) {
  planPackage(id: $planPackageId) {
    id
    name
    displayCode
    version {
      id
    }
    assets {
      id
      type {
        code
      }
      asset {
        id
        planPackagePreview: previewUrl(
          resizing: {width: 556, height: 320, region: FULL}
        )
      }
    }
  }
  exteriorDesignPackage: designPackage(id: $exteriorDesignPackageId) {
    ...Named
    version {
      id
    }
  }
  interiorDesignPackage: designPackage(id: $interiorDesignPackageId) {
    ...Named
    version {
      id
    }
  }
  readyPlanOptions(filter: $readyPlanOptionsFilter) {
    ...ReadOnlyReadyPlanOptionRow
  }
}
    ${NamedFragmentDoc}
${ReadOnlyReadyPlanOptionRowFragmentDoc}`;

/**
 * __useReviewStepQuery__
 *
 * To run a query within a React component, call `useReviewStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewStepQuery({
 *   variables: {
 *      planPackageId: // value for 'planPackageId'
 *      exteriorDesignPackageId: // value for 'exteriorDesignPackageId'
 *      interiorDesignPackageId: // value for 'interiorDesignPackageId'
 *      readyPlanOptionsFilter: // value for 'readyPlanOptionsFilter'
 *   },
 * });
 */
export function useReviewStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewStepQuery, ReviewStepQueryVariables> & ({ variables: ReviewStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewStepQuery, ReviewStepQueryVariables>(ReviewStepDocument, options);
      }
export function useReviewStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewStepQuery, ReviewStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewStepQuery, ReviewStepQueryVariables>(ReviewStepDocument, options);
        }
// @ts-ignore
export function useReviewStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewStepQuery, ReviewStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewStepQuery, ReviewStepQueryVariables>;
export function useReviewStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewStepQuery, ReviewStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewStepQuery | undefined, ReviewStepQueryVariables>;
export function useReviewStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewStepQuery, ReviewStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewStepQuery, ReviewStepQueryVariables>(ReviewStepDocument, options);
        }
export type ReviewStepQueryHookResult = ReturnType<typeof useReviewStepQuery>;
export type ReviewStepLazyQueryHookResult = ReturnType<typeof useReviewStepLazyQuery>;
export type ReviewStepSuspenseQueryHookResult = ReturnType<typeof useReviewStepSuspenseQuery>;
export type ReviewStepQueryResult = ApolloReactCommon.QueryResult<ReviewStepQuery, ReviewStepQueryVariables>;
export const ReviewStep_SaveProductOfferingDocument = gql`
    mutation ReviewStep_SaveProductOffering($input: SaveProductOfferingInput!) {
  saveProductOffering(input: $input) {
    productOffering {
      id
      version {
        id
      }
    }
  }
}
    `;

/**
 * __useReviewStep_SaveProductOfferingMutation__
 *
 * To run a mutation, you first call `useReviewStep_SaveProductOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewStep_SaveProductOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewStepSaveProductOfferingMutation, { data, loading, error }] = useReviewStep_SaveProductOfferingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewStep_SaveProductOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReviewStep_SaveProductOfferingMutation, ReviewStep_SaveProductOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviewStep_SaveProductOfferingMutation, ReviewStep_SaveProductOfferingMutationVariables>(ReviewStep_SaveProductOfferingDocument, options);
      }
export type ReviewStep_SaveProductOfferingMutationHookResult = ReturnType<typeof useReviewStep_SaveProductOfferingMutation>;
export type ReviewStep_SaveProductOfferingMutationResult = ApolloReactCommon.MutationResult<ReviewStep_SaveProductOfferingMutation>;